/**
 * i18next init options for the dashboard. Kept in its own module so tests can
 * import and exercise the real resolution config (supportedLngs, region strip,
 * fallback) without booting the Backend-backed singleton in src/i18n.ts.
 */
import { LOCALE_KEY } from "@/utils/localstorage-keys";

import type { InitOptions } from "i18next";

export const i18nOptions: InitOptions = {
  supportedLngs: ["en", "es", "fr"],
  // Regional browser locales (es-US, es-MX, fr-CA) load the base-language file.
  load: "languageOnly",
  backend: {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
  },
  ns: ["common"],
  defaultNS: "common",
  fallbackLng: "en",
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
    lookupLocalStorage: LOCALE_KEY,
  },
};
